import { client } from './api';

class CategoriesService {
  getCategories = async () => {
    const response = await client.get('category/all');
    return response;
  };
}

export default new CategoriesService();
